<mat-dialog-content>
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step [completed]="this.List.length > 0" label="Upload the articler">
      <div class="row">
        <div class="col-12">
          <p>Please follow the next steps carefully.</p>
          <ol>
            <li>Download the excel <a (click)="export()">here.</a></li>
            <li>Complete the excel, <strong>modify the column order</strong>.</li>
            <li>Upload the excel with the button below and click on "next".</li>
          </ol>
          <p></p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form>
            <input (change)="readFile($event);" name="file" type="file">
          </form>
        </div>
      </div>
    </mat-step>
    <mat-step [completed]="true" label="Validate">
      <div class="row ">
        <div class="col-12" style="overflow:scroll;">
          <table class="mat-mdc-table">
            <tr>
              <th>Article code</th>
              <th>Description</th>
              <th>Order</th>
              <th>Imported</th>
              <th></th>
            </tr>
            <ng-container *ngFor="let row of List">
              <tr *ngIf="!showOnlyErrors || (showOnlyErrors && row.error)">
                <td>{{row.obj.Code}}</td>
                <td>{{row.obj.Description}}</td>
                <td>{{row.obj.Order}}</td>
                <td>
                  <mat-icon>{{row.imported ? 'check' : 'clear'}}</mat-icon>
                </td>
                <td>
                  <mat-icon *ngIf="row.error" [matTooltip]="row.error">warning</mat-icon>
                  <ng-container *ngIf="row.loading">
                    <mat-spinner class="spinner" color="accent" diameter="18"></mat-spinner>
                  </ng-container>
                  <button (confirm)="removeRow(row)" appConfirmDialog class="text-right" mat-icon-button matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
    </mat-step>
    <mat-step [completed]="true" label="Import">
      <div *ngIf="numErrors() > 0" class="row">
        <div class="col-12">
          <p class="p-3 w-100 bg-warning msgbox">
            Aww, there were {{numErrors()}} errors. <strong>Please go back and fix the errors, and try again.</strong>
          </p>
        </div>
      </div>

      <div *ngIf="numTogo() === 0" class="row">
        <div class="col-12">
          <p class="p-3 w-100 bg-success msgbox">
            Wooof!! All the {{this.List.length}} articles <strong>have been sorted, paw!</strong>
          </p>
        </div>
      </div>

      <div *ngIf="!isLoading()" class="row">
        <div class="col-12 pb-4">
          <p>Click on "Import" to start importing.</p>
          <mat-progress-bar [value]="getProgression()" mode="determinate"></mat-progress-bar>
        </div>
      </div>

      <div *ngIf="isLoading()" class="row">
        <div class="col-12 pb-4">
          <p>Please be patient, I am working. <strong>There are currently {{numReady()}} of {{this.List.length}} articles updated</strong>.</p>
          <mat-progress-bar [value]="getProgression()" mode="determinate"></mat-progress-bar>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>

<mat-dialog-actions>
  <ng-container [ngSwitch]="stepper.selectedIndex">
    <ng-container *ngSwitchCase="0">
      <div class="fill-remaining-space"></div>
      <button (click)="stepper.next()" mat-button type="button">Next</button>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <button (click)="stepper.previous()" class="float-left" mat-button type="button">Back</button>
      <div class="fill-remaining-space"></div>
      <button (click)="import()" [disabled]="isLoading() || numTogo() === 0" class="float-right" mat-button type="button">{{numErrors() > 0 ? 'Re-try to import' : 'Import'}}</button>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <button (click)="stepper.previous()" mat-button type="button">Back</button>
      <div class="fill-remaining-space"></div>
      <button (click)="stepper.next()" mat-button type="button">Next</button>
    </ng-container>
  </ng-container>
</mat-dialog-actions>
